/**
 * Display label for a table number.
 *
 * Numeric tables (1, 2, "10") render as "T1", "T2", "T10".
 * Alphanumeric tables ("RT12", "PATIO3") render as-is so the floor staff
 * read the actual section prefix (e.g. RT = Rooftop).
 *
 * Handles null / undefined gracefully → returns "T?".
 */
export function tableLabel(n) {
  if (n === null || n === undefined || n === '') return 'T?';
  const s = String(n);
  // Pure digit string → prepend T. Anything starting with a letter → use as-is.
  return /^\d+$/.test(s) ? `T${s}` : s;
}
